"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryLanguagesService = exports.CountryLanguagesService = void 0;
class CountryLanguagesService {
    getAllCounrtiesFromRegions(regions) {
        const allCoutries = [];
        for (const region of regions) {
            for (const country of region.items) {
                allCoutries.push(country);
            }
        }
        return allCoutries;
    }
    sortCountries(countries) {
        return countries
            .slice(0)
            .sort((a, b) => a.countryName.localeCompare(b.countryName));
    }
    addGlobalCountry(globalCountry, countries) {
        return [globalCountry, ...countries];
    }
    mergeCountriesWithDifferentLanguages(countries) {
        const mergedCountries = [];
        let prevCountryIndex = 0;
        let prevCountry;
        countries.map(country => {
            if (!country.countryName)
                return;
            if (!mergedCountries.length || prevCountry.countryName !== country.countryName) {
                mergedCountries.push(Object.assign(Object.assign({}, country), { isMultiLanguage: false, languages: [{ name: country.countryLanguage, url: country.url }] }));
                prevCountryIndex = mergedCountries.length - 1;
                prevCountry = mergedCountries[prevCountryIndex];
            }
            else {
                prevCountry.languages.push({ name: country.countryLanguage, url: country.url });
                prevCountry.isMultiLanguage = true;
            }
        });
        return mergedCountries;
    }
    coutriesArrayBuilder(regions, globalCountry) {
        if (regions.length && typeof regions !== 'string' && typeof globalCountry !== 'string') {
            const allCounries = this.getAllCounrtiesFromRegions(regions);
            const sortedCountries = this.sortCountries(allCounries);
            const sortedCountriesWithGlobalFirst = this.addGlobalCountry(globalCountry, sortedCountries);
            return this.mergeCountriesWithDifferentLanguages(sortedCountriesWithGlobalFirst);
        }
        return [];
    }
    returnModifiedCurrentCountry(currentCountry, countries) {
        const modifiedCurrentCountry = countries.find(country => {
            if (currentCountry.countryName === country.countryName)
                return country;
        });
        return Object.assign(Object.assign({}, modifiedCurrentCountry), { currentLanguageUrl: currentCountry.url, url: '', countryLanguage: '', geoRegion: '' });
    }
}
exports.CountryLanguagesService = CountryLanguagesService;
exports.countryLanguagesService = new CountryLanguagesService();
